import React from 'react'

const Statement = () => {
  return (
    <div className="mace-statement">
      <h4>Statement of The Problem</h4>
      <p>
        As Mace is moving towards new economies while expanding its product. There is an urgent need to adopt technological measures to allow wider outreach by consumers. <br />
        Thus, the decision is made to create a marketplace for the company’s products in a user friendly manner that will convey the brand effortlessly
      </p>
    </div>
  )
}

export default Statement